import { truncateSelectedValues, formatSelectionsArray } from './utils'
import { driveTypesData } from '@cinch-nx/data-search'

export const getFormattedDriveType = (driveTypeSelections: string[] = []) =>
  truncateSelectedValues(
    formatSelectionsArray(driveTypeSelections, driveTypesData),
  )
